import React from 'react';
import ScenarioPlanner from '../../components/ScenarioPlanner';

// Scenario Planning inside the client dashboard — same panel chrome as FullReport.
const ScenarioPanel = ({ companyName, financialYear, beeLevel, onClose }) => (
  <div className="cd-panel" style={{ '--a': 'var(--teal)' }}>
    <div className="cd-panel-head">
      <div className="cd-panel-htext">
        <div className="nm"><span className="dot" /> Scenario planning</div>
        <div className="sub">{companyName} · {financialYear?.label}</div>
      </div>
      <div className="cd-panel-hmeta">
        <div className="pts">{beeLevel?.level || '—'}</div>
      </div>
      <button type="button" className="cd-panel-x" onClick={onClose} aria-label="Close">×</button>
    </div>

    <div className="cd-panel-body">
      <ScenarioPlanner />
    </div>
  </div>
);

export default ScenarioPanel;
